var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"slider",attrs:{"id":"my-slider","se-min":_vm.minThreshold,"se-step":_vm.step,"se-min-value":_vm.min,"se-max-value":_vm.max,"se-max":_vm.maxThreshold}},[_vm._m(0),_vm._m(1),_vm._m(2)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"slider-touch-left"},[_c('span')])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"slider-touch-right"},[_c('span')])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"slider-line"},[_c('span')])
}]

export { render, staticRenderFns }